import EventDetailsModal from '@/components/calendar/EventDetailsModal';

interface DisplayEvent {
  id: string | number;
  title: string;
  start: string;
  end: string;
  all_day: boolean;
  description?: string | null;
  isAiEvent?: boolean;
  community_id?: number;
  created_by?: string;
  created_at?: string;
  updated_at?: string;
  community?: {
    id: number;
    name: string;
  };
  post?: {
    id: number;
    title: string;
  };
  poll?: {
    id: number;
    question: string;
  };
  groupNegotiation?: {
    id: number;
    title: string;
  };
  reminders?: Array<{
    id: number;
    calendar_event_id: number;
    remind_at: string;
    type: string;
    unit: string;
    value: number;
    sent: boolean;
    created_at: string;
    updated_at: string;
  }>;
  recurringSettings?: {
    id: number;
    calendar_event_id: number;
    pattern: string;
    every: number;
    period: string;
    end_date: string | null;
    created_at: string;
    updated_at: string;
  };
  metadata?: Record<string, unknown>;
}

interface CommunityEventDetailsModalProps {
  event: DisplayEvent;
  onClose: () => void;
  onEditClick?: (event: DisplayEvent) => void;
  onEventUpdated?: () => void;
}

const CommunityEventDetailsModal = ({
  event,
  onClose,
  onEditClick,
  onEventUpdated,
}: CommunityEventDetailsModalProps) => 
  // For now, we'll reuse the existing EventDetailsModal
  // In the future, we can customize this specifically for community events
  // to show community-specific information
  <EventDetailsModal
    event={event}
    onClose={onClose}
    onEditClick={onEditClick}
    onEventUpdated={onEventUpdated}
  />;

export default CommunityEventDetailsModal;